import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const freelancerManagement = {
    "id": "EMs04U",
    "name": "Contractor Management",
    "img": "/app/static/templates/hr/contractors.jpg",
    "description": "Template to record key contractor information and contract details.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    demoFolderColor: 8
};

const jobRecruitment = {
    "id": "tnccVu",
    "name": "Job Recruitment",
    "img": "/app/static/templates/hr/recruitment.jpg",
    "description": "Structure and workflow to manage recruitment for any role.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

const onboarding = {
    "id": "Kz2ZwM",
    "name": "Employee Onboarding",
    "img": "/app/static/templates/hr/onboarding.jpg",
    "description": "Use this template to design employee onboarding plans.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    wipeTemplateContent: false,
    demoFolderColor: 8
};

const organizationalChart = {
    "id": "URjNeV",
    "name": "Organizational Chart",
    "img": "/app/static/templates/hr/org-chart.jpg",
    "description": "An organized table view of the reporting structure and staff details.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    demoFolderColor: 8
};

const hrRequests = {
    "id": "S05xLg",
    "name": "HR Requests",
    "img": "/app/static/templates/hr/hr-requests.jpg",
    "description": "Convenient HR request tracker to prioritize and execute.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    demoFolderColor: 8
};

export default {
    id: 'hr',
    name: "HR",
    items: [

        jobRecruitment,
        onboarding,
        freelancerManagement,
        organizationalChart,
        hrRequests
    ]
};